import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { getCampaignSuccess } from '../steps/actions'
import { validateMessageStep } from '../steps/MessageStep/actions'
import { validateStepFields } from '../steps/SetupStep/actions'

import { getCampaignError, getCampaignSuccess as getEditCampaignSuccess } from './actions'
import { GET_CAMPAIGN_ASYNC, INIT_EDIT_MODE } from './constants'

const getCampaignEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(INIT_EDIT_MODE).mergeMap((action) =>
    api.wizardCampaign
      .getCampaign(
        store.getState().partnerOptions.selectedCompany?.value,
        action.payload.campaignId
      )
      .mergeMap((response) =>
        Observable.of(
          getEditCampaignSuccess(response.flow_type),
          getCampaignSuccess(response),
          validateStepFields(),
          validateMessageStep()
        )
      )
      .catch((error) => Observable.of(epicsErrorHandler(getCampaignError, error, [400])))
      .takeUntil(action$.ofType(GET_CAMPAIGN_ASYNC.CANCEL))
  )

export default combineEpics(getCampaignEpic)
